import * as React from 'react';
import {useCallback} from 'react';

import {captureError} from '../../integrations';
import {ErrorBoundary} from '../ErrorBoundary';
import {useTrackWorkspaceError} from './utils';
import {WorkspaceResetContent} from './WorkspaceResetContent';

type WorkspaceErrorBoundaryProps = {
  workspaceStateId: string;
  viewType: 'project-view' | 'sweep-view' | 'group-view' | 'run-view';
  children: JSX.Element;
};

export const WorkspaceErrorBoundary = ({
  children,
  workspaceStateId,
  viewType,
}: WorkspaceErrorBoundaryProps) => {
  const trackWorkspaceError = useTrackWorkspaceError({
    action: 'View',
    errorType: 'Error boundary',
    viewType,
  });

  const logWorkspaceError = useCallback(
    (error: Error, info: React.ErrorInfo) => {
      captureError(error, 'WorkspaceErrorBoundary', {
        extra: Object.assign(info, {
          viewtype: viewType,
        }),
      });
      trackWorkspaceError(error);
    },
    [trackWorkspaceError, viewType]
  );

  return (
    <ErrorBoundary
      onError={logWorkspaceError}
      renderError={() => (
        <WorkspaceResetContent
          workspaceStateId={workspaceStateId}
          viewType={viewType}
        />
      )}>
      {children}
    </ErrorBoundary>
  );
};
